import { FC } from "react";

import { VnBox } from "@/components/VnBox";
import { VnImage } from "@/components/VnImage";
import { VnText } from "@/components/VnText/VnText";
import { useClinicsQuery } from "@/data/queries/clinicsQueries";
import { convertBase64ToDataUri } from "@/utils/image";

import { SupportCallButton } from "./SupportCallButton";

export const AppFooter: FC = () => {
  const { data: clinics } = useClinicsQuery();

  const clinicLogoUris = (clinics ?? [])
    .map(c => c.logoBase64)
    .filter((logo): logo is string => Boolean(logo))
    .map(convertBase64ToDataUri);
  const hasClinicLogos = clinicLogoUris.length > 0;

  return (
    <VnBox className="bg-secondary pb-safe px-5 py-6">
      <VnBox className="w-full max-w-screen-md flex-row flex-wrap items-center justify-around gap-x-4 gap-y-2 self-center px-4">
        <SupportCallButton className="h-12 min-w-36 shrink-0 rounded-full px-7" />
        {hasClinicLogos && (
          <VnBox className="shrink-0 items-center gap-1">
            <VnText
              variant="mdMedium"
              className="text-foreground text-center"
              i18nKey="native:appFooter.partnershipLabel"
            />
            {clinicLogoUris.map((uri, index) => (
              <VnImage
                key={`clinic_logo_${index}`}
                source={{ uri }}
                contentFit="contain"
                className="h-8 w-32"
              />
            ))}
          </VnBox>
        )}
      </VnBox>
    </VnBox>
  );
};
